<div class="col-12 px-0">
    <div class="mb-4" *ngIf="fb && fb.error">
        <lib-error [title]="getErrorMsgText()" [error]="fb.error"></lib-error>
    </div>

    <form [formGroup]="form">
        <lib-text-box [control]="form.controls.query" 
                      [idName]="'tagSearchQuery'"
                      [labelBlock]="false" 
                      [placeHolder]="'Search for a product tag here'">
        </lib-text-box>
    </form>

    <!-- searchResultsShownInTagsAdmin can be passed as true from tag-admin component where its usedif its not used in 
     tag-admin we assume that its then being used in the products tags tab, where it requires styling differently -->
    <div *ngIf="searchInput && searchInput.length >= charactersReqForAutoSearch" [ngClass]="searchResultsShownInTagsAdmin ? 'panel-tags-admin' : 'dropdown-panel-tags-tab'">
        <div class="d-flex align-items-center justify-content-end">
            <button type="button" class="close" aria-label="Close" (click)="closeDropdownPanel()">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647
                        2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        </div>
        <div [ngClass]="searchResultsShownInTagsAdmin ? 'inner-panel-admin' : 'dropdown-inner-panel-tags-tab'">
            <ng-container *ngIf="searchResults else loading">
                <ng-container *ngIf="searchResults.length > 0; else empty">
                    <ng-container *ngFor="let result of searchResults">
                        <ng-container *ngIf="searchResultsShownInTagsAdmin; else searchResultsShownInTagsTab">
                            <app-product-tag [tagInfo]="result" [searchQuery]="searchInput" [usedInTagsAdmin]="true" 
                                (tagSelected)="tagSelected($event)" [newTag]="result.newTag" (tagToBeDeleted)="deleteTag($event)">
                            </app-product-tag>
                        </ng-container>
                        <ng-template #searchResultsShownInTagsTab>
                            <app-product-tag [tagInfo]="result" [searchQuery]="searchInput"
                                (tagSelected)="tagSelected($event)" [newTag]="result.newTag">
                            </app-product-tag>
                        </ng-template>
                    </ng-container>
                </ng-container>
                <ng-template #empty>
                    No tags found that match "{{ searchInput }}". <span *ngIf="disableCreateButton">A tag representing your search may already be assigned to this product.</span>
                </ng-template>
            </ng-container>
            <ng-template #loading>
                <lib-loading style="width: 200px" [status]="'text-info'" [spinnerPosition]="true" [size]="'md'"></lib-loading>
            </ng-template>
        </div>
        <div class="button-container">
            <button *ngIf="!searchResultsShownInTagsAdmin" class="btn btn-primary" [disabled]="!selectedTags.length" (click)="addSelectedTags()">
                Add Selected Tags
            </button>
            <button class="btn btn-primary" *ngIf="canCreate" [disabled]="disableCreateButton" (click)="createNewTag()">Create A New Tag</button>
        </div>
    </div>
</div>

<ng-template class="modal-lg" let-modal #createNewTagModal>
    <div class="modal-header d-flex align-items-center">
        <h6 class="modal-title">Create a New Tag</h6>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 
                    2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
        </button>
    </div>
    <div class="modal-body p-0">
        <app-create-product-tag [prefill]="searchInput" (closeModal)="closeModal()" (saveCloseModal)="saveCloseModal($event)"
            [tagTypes]="tagTypes"></app-create-product-tag>
    </div>
</ng-template>

<ng-template class="modal-lg" let-modal #editTagModal>
    <div class="modal-header d-flex align-items-center">
        <h6 class="modal-title">Edit an Existing Tag</h6>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 
                    2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
        </button>
    </div>
    <div class="modal-body p-0">
        <app-edit-product-tag [tagId]="tagToEditId" (closeModal)="closeModal()" (saveCloseModal)="saveCloseModal($event)" 
            [tagTypes]="tagTypes"></app-edit-product-tag>
    </div>
</ng-template>